import { NavigateFunction } from 'react-router-dom';

export const handleFieldNavigation = (navigate: NavigateFunction, field: string, value: string) => {
  switch (field) {
    case 'user_id':
      navigate(`/users/${value}`);
      break;
    case 'order_id':
      navigate(`/admin/trading/orders/${value}`);
      break;
    default:
      break;
  }
};
